export default {
	"faq-class-name": "en-faq-new",
	"faq-title":"FAQ",
	"faq-desc": "สอบถามคำถามที่พบบ่อยหรือติดต่อฝ่ายบริการลูกค้าโดยตรง ทีมสนับสนุนลูกค้า EBC รอคำถามของคุณอยู่เสมอ",
	"faq-search": "ป้อนคำค้นหา",
	"faq-tabs":[
		"การลงทะเบียนและการเปิดบัญชี",
		"การฝากและถอนเงิน",
		"การทำธุรกรรมที่เกี่ยวข้อง",
		"สถานีซื้อขาย",
		"ความรู้",
	],
	"faq-data":{
		0: [
			{
				"Q": " จะเริ่มซื้อขาย EBC ได้อย่างไร?",
				"A": " ทำตามขั้นตอนต่อไปนี้เพื่อเริ่มต้นการซื้อขายบน EBC: 1. ลงทะเบียนสำหรับบัญชี EBC 2. ตรวจสอบข้อมูลส่วนบุคคล 3. เปิดบัญชีการซื้อขายและฝากเงิน 4. เข้าสู่ระบบเทอร์มินัลการซื้อขาย MT4 เพื่อซื้อขาย"
			},
			{
				"Q": " เป็นไปได้ไหมที่จะลงทะเบียนบัญชี EBC หลายบัญชีโดยใช้ที่อยู่อีเมลเดียวกัน",
				"A": " ขออภัย ที่อยู่อีเมลสามารถลงทะเบียนกับบัญชี EBC ได้เพียงบัญชีเดียวเท่านั้น อย่างไรก็ตาม บัญชี EBC หนึ่งบัญชีสามารถสร้างบัญชีซื้อขายได้หลายบัญชี"
			},
			{
				"Q": " จุดประสงค์ของการยืนยัน KYC ให้เสร็จสิ้นคืออะไร?",
				"A": " ในฐานะบริษัทที่ปฏิบัติตามและได้รับการควบคุม เราจำเป็นต้องดำเนินการตรวจสอบ KYC ตามระเบียบข้อบังคับที่กำหนดโดยหน่วยงานกำกับดูแลที่มีอำนาจ ซึ่งเกี่ยวข้องกับการรวบรวมข้อมูลการตรวจสอบ KYC ของคุณ เช่น บัตรประจำตัวประชาชนที่ถูกต้อง และหลักฐานที่อยู่ที่ออกให้ภายในหกเดือนที่ผ่านมา"
			},
			{
				"Q": " ต้องใช้เอกสารอะไรบ้างในการตรวจสอบบัญชี EBC?",
				"A": "คุณจะต้องแจ้ง ID หมายเลขโทรศัพท์มือถือ และที่อยู่อีเมลที่ถูกต้องแก่เราเพื่อทำการตรวจสอบ KYC ให้เสร็จสิ้น"
			},
			{
				"Q": " ฉันจะส่งเอกสารยืนยันอีกครั้งได้อย่างไร?",
				"A": " นี่คือกระบวนการในการส่งเอกสาร KYC ของคุณอีกครั้ง: 1. เข้าสู่พอร์ทัลลูกค้าของคุณ และไปที่บัญชีของฉัน 2. ในส่วนข้อมูลส่วนบุคคล ให้กรอกข้อมูลของคุณอีกครั้งตามที่ร้องขอ 3. คลิกที่ปุ่มลบถัดจากเอกสารที่ส่งก่อนหน้านี้ จากนั้นอัปโหลดใหม่ 4. เมื่อเสร็จแล้ว นั่งพักผ่อนเพราะเอกสาร KYC ของคุณจะถูกตรวจสอบเร็วๆ นี้"
			},
			{
				"Q": " ฉันจะอัปเดตข้อมูลส่วนบุคคลของฉันในบัญชี EBC ของฉันได้อย่างไร",
				"A": " โปรดทราบว่าไม่อนุญาตให้แก้ไขชื่อที่ลงทะเบียนของคุณ อย่างไรก็ตาม คุณยังคงสามารถอัปเดตหมายเลขโทรศัพท์มือถือ ที่อยู่อีเมล และข้อมูลธนาคารที่ลงทะเบียนไว้ได้"
			},
			{
				"Q": " เงินและข้อมูลส่วนบุคคลของฉันปลอดภัยหรือไม่?",
				"A": "ความปลอดภัยของเงินทุนของคุณมีความสำคัญสูงสุดสำหรับเรา เราได้รับการดูแลอย่างใกล้ชิดจากหน่วยงานกำกับดูแลชั้นนำหลายแห่งทั่วโลก และปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้องอย่างเคร่งครัด เงินของลูกค้าจะถูกจัดเก็บแยกกันในแต่ละบัญชีที่ธนาคารในต่างประเทศที่มีชื่อเสียง เพื่อให้มั่นใจว่าได้รับการคุ้มครองเป็นสองเท่าสำหรับทั้งเงินทุนและรายได้จากการลงทุนของคุณ นอกจากนี้เรายังทุ่มเทในการใช้มาตรการรักษาความปลอดภัยที่จำเป็นทั้งหมดเพื่อปกป้องข้อมูลส่วนบุคคลของคุณ"
			},
			{
				"Q": " มีบัญชีประเภทใดบ้าง?",
				"A": " เรามีบัญชี 2 ประเภท: บัญชีมาตรฐานและบัญชีมืออาชีพ <a href=\"/TradingAccount\">คลิกที่นี่เพื่อดูตารางเปรียบเทียบบัญชี </a>"
			},
			{
				"Q": " จะค้นหาหมายเลขบัญชีซื้อขายของฉันได้อย่างไร?",
				"A": " หากต้องการค้นหาหมายเลขบัญชีซื้อขาย ให้ทำตามขั้นตอนด้านล่าง: 1. เข้าสู่บัญชี EBC ของคุณ 2. คลิก \"หน้าแรก\" - \"บัญชีจริง\" 3. ใต้บัญชีจริง คุณจะเห็นหมายเลขบัญชีซื้อขายของคุณ"
			},
			{
				"Q": " มีความแตกต่างระหว่างก สด บัญชีและบัญชีซื้อขายทดลอง?",
				"A": "กระบวนการซื้อขาย ผลิตภัณฑ์การซื้อขาย และแนวโน้ม K-line ของทั้งสองมีความสอดคล้องกัน การดำเนินการของบัญชีจริงต้องมีความเสี่ยงทางการเงินที่เกิดขึ้นจริง บัญชีทดลองช่วยให้ผู้ใช้เรียนรู้และเข้าใจการเปลี่ยนแปลงของตลาดโดยไม่ต้องใช้เงินจริง"
			},
			{
				"Q": " สำนักงาน EBC อยู่ที่ไหน?",
				"A": " เรามีสำนักงานในศูนย์กลางทางการเงินที่สำคัญ เช่น ลอนดอน โตเกียว ซิดนีย์ สิงคโปร์ และฮ่องกง โปรดดูที่เว็บไซต์ของเราสำหรับข้อมูลเพิ่มเติมหากคุณต้องการ"
			},
			{
				"Q": " มีการจำกัดอายุในการเปิดบัญชีหรือไม่?",
				"A": " หากต้องการเปิดบัญชี คุณต้องมีอายุอย่างน้อย 18 ปี และไม่เกิน 65 ปี ยกเว้นลูกค้าที่อาศัยอยู่ในญี่ปุ่น ซึ่งจำกัดอายุสูงสุดคือ 70 ปี"
			},
			{
				"Q": " EBC ไม่รับลูกค้าจากประเทศใดบ้าง?",
				"A": "โปรดทราบว่าผลิตภัณฑ์และบริการของเราไม่มีให้บริการแก่ลูกค้าที่อาศัยอยู่ในบางภูมิภาค รวมถึงสหรัฐอเมริกา แคนาดา มาเลเซีย และอื่นๆ รายชื่อประเทศที่ถูกจำกัดอาจมีการอัปเดตเป็นระยะ สำหรับรายละเอียดเพิ่มเติม โปรดติดต่อทีมสนับสนุนลูกค้าของเราผ่านทาง LiveChat"
			},
			{
				"Q": " จะลบบัญชีของฉันได้อย่างไร?",
				"A": " เราเสียใจที่ทราบว่าคุณต้องการลบบัญชีของคุณ โปรดส่งคำขอไปที่ cs@ebc.com โดยใช้ที่อยู่อีเมลที่ลงทะเบียนของคุณ เพื่อให้เราสามารถช่วยเหลือคุณได้ดียิ่งขึ้น หลังจากได้รับคำขอของคุณแล้ว ฝ่ายสนับสนุนลูกค้าจะจัดการเรื่องนี้"
			},
			{
				"Q": " ฉันจะอัพเดตเลเวอเรจบัญชีซื้อขายของฉันได้อย่างไร?",
				"A": " แน่นอน หากต้องการอัปเดตเลเวอเรจของคุณ โปรดทำตามขั้นตอนด้านล่าง: 1. เข้าสู่พอร์ทัลลูกค้าของคุณแล้วคลิกหน้าแรก 2. ใต้บัญชีของฉัน - แตะที่ \"การตั้งค่า\" ทางด้านขวาของบัญชี - \"แก้ไขเลเวอเรจ\" 3. เลือก เลเวอเรจที่เหมาะสมและคลิก \"ใช่\" เพื่ออัปเดตเลเวอเรจของคุณ"
			},
			{
				"Q": "ฉันจะทำอย่างไรโดยติดต่อฝ่ายบริการลูกค้า? เวลาทำงานคือเท่าไร?",
				"A": " หากคุณมีข้อสงสัยเกี่ยวกับการลงทะเบียน การดาวน์โหลดแพลตฟอร์ม หรือหัวข้ออื่นๆ ที่เกี่ยวข้อง ทีมสนับสนุนลูกค้าของเราพร้อมให้ความช่วยเหลือคุณตลอดเวลา คุณสามารถส่งอีเมลถึงเราได้ที่ cs@ebc.com หรือใช้บริการลูกค้าออนไลน์เพื่อติดต่อเรา"
			},
			{
				"Q": " หากจำเป็นต้องยื่นเรื่องร้องเรียนมีขั้นตอนอย่างไร?",
				"A": " ขออภัยในความไม่สะดวกที่อาจเกิดขึ้น การรับรองความพึงพอใจของคุณเป็นสิ่งสำคัญที่สุดของเรา และเรามุ่งมั่นที่จะแก้ไขปัญหาใดๆ ที่คุณอาจพบ หากคุณมีข้อร้องเรียนใด ๆ โปรดอย่าลังเลที่จะส่งอีเมลถึงเราที่ cs@ebc.com"
			}
		],
		1: [
			{
				"Q": " ฉันต้องรู้อะไรก่อนทำการฝากเงิน?",
				"A": "EBC เสนอวิธีการฝากเงินทุกวันตลอด 24 ชั่วโมง สิ่งสำคัญคือต้องชำระเงินให้เสร็จสิ้นภายในระยะเวลาที่กำหนดเมื่อทำการฝากเงิน ไม่เช่นนั้นคำสั่งการฝากเงินจะถูกยกเลิกโดยอัตโนมัติ วิธีการฝากที่แตกต่างกันอาจมีขีดจำกัดการฝากที่แตกต่างกัน ดังนั้นจึงแนะนำให้ตรวจสอบรายละเอียดที่เกี่ยวข้องก่อนที่จะฝากเงิน"
			},
			{
				"Q": " ฉันต้องรู้อะไรบ้างก่อนส่งคำขอถอนเงิน?",
				"A": " เรามีวิธีการถอนเงินหลายวิธี รวมถึงการโอนเงินผ่านธนาคารในประเทศ สกุลเงินดิจิทัล และการโอนเงินผ่านธนาคารระหว่างประเทศ โปรดทราบว่าจำนวนเงินถอนขั้นต่ำคือ 100 เหรียญสหรัฐสำหรับการโอนเงินผ่านธนาคารในประเทศและการโอนเงินผ่านธนาคารระหว่างประเทศ และ 50 เหรียญสหรัฐสำหรับการถอนเงินสกุลเงินดิจิตอล"
			},
			{
				"Q": " วิธีการฝากเงิน?",
				"A": "หากต้องการฝากเงิน โปรดทำตามขั้นตอนด้านล่าง: 1. เข้าสู่ระบบพอร์ทัลลูกค้าของคุณแล้วแตะกองทุน 2. ค้นหาเงินฝากที่อยู่ทางด้านขวาของเมนู 3. เลือกวิธีการฝากเงินที่คุณต้องการและเลือกบัญชีซื้อขายที่คุณต้องการ ต้องการรับเงิน 4. กรอกจำนวนเงินแล้วคลิกยืนยันการชำระเงิน 5. คุณจะถูกนำไปยังหน้าผู้ขาย และโปรดปฏิบัติตามคำแนะนำเพื่อทำการฝากเงินให้เสร็จสิ้น"
			},
			{
				"Q": " ฉันสามารถฝาก/ถอนเงินโดยใช้บัตรธนาคารของผู้อื่นได้หรือไม่?",
				"A": "EBC ไม่ยอมรับการชำระเงินของบุคคลที่สาม เงินฝากทั้งหมดจะต้องมาจากบัญชีในชื่อของคุณ (เงินฝากทั้งหมดจะต้องมาจากบัญชีธนาคารของคุณเอง) หากเราสงสัยว่าเงินมาจากบุคคลที่สาม เราขอสงวนสิทธิ์ในการคืนเงินให้กับผู้ส่งเงินและระงับยอดเงินในบัญชีของคุณชั่วคราวจนกว่าจะมีการยืนยันตัวตนและแหล่งที่มาของเงินทุน สมบูรณ์. ในกรณีที่ไม่มีการตรวจสอบ เราขอสงวนสิทธิ์ในการอายัดยอดเงินในบัญชีของคุณ และคุณจะไม่สามารถถอนยอดเงินในบัญชีของคุณได้ในขณะนี้ EBC ไม่จัดการการถอนเงินไปยังบุคคลที่สาม ในกรณีมีสถานการณ์พิเศษ โปรดติดต่อเรา"
			},
			{
				"Q": " วงเงินฝากคืออะไร?",
				"A": " วิธีการชำระเงินที่แตกต่างกันมีขีดจำกัดการฝากที่แตกต่างกัน โปรดดูที่หน้าการฝากเงินสำหรับข้อมูลเพิ่มเติม"
			},
			{
				"Q": " EBC เรียกเก็บค่าธรรมเนียมการฝากหรือถอนเงินหรือไม่?",
				"A": " EBC ไม่คิดค่าธรรมเนียมการจัดการสำหรับการฝากและถอนเงิน โปรดทราบว่าผู้ให้บริการสกุลเงินดิจิทัลบางรายอาจเรียกเก็บค่าธรรมเนียมการจัดการบางอย่าง"
			},
			{
				"Q": "ฉันสามารถฝากและถอนเงินนอกเวลาทำการได้หรือไม่?",
				"A": " คุณสามารถส่งคำขอฝากและถอนเงินได้ตามปกติแม้ในวันหยุดสุดสัปดาห์และวันหยุดนักขัตฤกษ์ อย่างไรก็ตาม โปรดทราบว่าเนื่องจากวันหยุดสุดสัปดาห์ไม่ทำงาน การประมวลผลคำขอของคุณอาจล่าช้าและจะดำเนินการในวันทำการถัดไป (วันจันทร์) เป็นอย่างช้าที่สุด"
			},
			{
				"Q": " การฝากและถอนเงินใช้เวลานานเท่าใด?",
				"A": " ภายใต้สถานการณ์ปกติ เวลาดำเนินการฝากเงินในวันทำการจะอยู่ที่ประมาณ 1 ถึง 15 นาที คำขอถอนเงินที่ส่งก่อน 16:00 UTC+8 ในวันทำการสามารถโอนเข้าบัญชีได้ทันทีในวันเดียวกัน"
			},
			{
				"Q": " ฉันสามารถฝากและถอนเงินผ่านบัตรธนาคารหลายใบได้หรือไม่",
				"A": " ใช่ คุณสามารถใช้บัตรธนาคารใดก็ได้ที่เป็นชื่อของคุณเอง"
			},
			{
				"Q": " ฉันสามารถถอนเงินจากบัญชีซื้อขายที่ยังมีคำสั่งที่เปิดอยู่ได้หรือไม่?",
				"A": "ใช่ อย่างไรก็ตาม โปรดทราบว่าจะต้องมีเงินทุนเพียงพอในบัญชีเพื่อหลีกเลี่ยงการชำระบัญชีคำสั่งซื้อที่เปิดอยู่เนื่องจากการดำเนินการถอนเงิน หากแผนกควบคุมความเสี่ยงพิจารณาว่าการดำเนินการถอนเงินอาจนำไปสู่การชำระบัญชี การสมัครถอนเงินจะถูกปฏิเสธ การดำเนินการถอนสามารถดำเนินการได้หลังจากการดำเนินการชำระบัญชีเสร็จสิ้นแล้วเท่านั้น"
			},
			{
				"Q": " ฉันสามารถใช้วิธีการชำระเงินอื่นนอกเหนือจากการฝากเงินเมื่อถอนเงินได้หรือไม่?",
				"A": " คุณสามารถถอนเงินฝากเริ่มแรกได้โดยใช้วิธีเดียวกับการฝากเงินของคุณ อย่างไรก็ตาม คุณมีความยืดหยุ่นในการถอนกำไรโดยใช้วิธีการถอนเงินที่คุณต้องการ"
			},
			{
				"Q": " เหตุใดการถอน/การฝากเงินจึงล้มเหลว?",
				"A": "ความล้มเหลวในการฝาก/ถอนอาจเกิดจากสาเหตุต่อไปนี้: 1. คุณกำลังฝากเงินโดยใช้บัตรธนาคารที่ไม่ใช่ชื่อของคุณ 2. บัตรธนาคารที่คุณใช้ไม่ทำงานหรือไม่ได้รับการยอมรับ 3. เมื่อทำการโอนเงิน ธนาคาร ข้อมูลหรือข้อมูลบัญชีถอนเงินกรอกไม่ถูกต้อง หากคุณพบสถานการณ์ข้างต้น โปรดติดต่อฝ่ายสนับสนุนลูกค้าของเราผ่านทาง LiveChat หรือส่งอีเมลไปที่ cs@ebc.com เพื่อขอความช่วยเหลือ"
			},
			{
				"Q": " ฉันสามารถโอนเงินระหว่างบัญชีซื้อขายของฉันได้หรือไม่?",
				"A": " ใช่. คุณสามารถส่งคำขอโอนเงินระหว่างบัญชีซื้อขายของคุณได้"
			},
			{
				"Q": " เหตุใดหลังจากส่งคำขอถอนเงินหนึ่งรายการแล้ว ฉันจึงไม่สามารถส่งอีกคำขอหนึ่งได้",
				"A": " ก่อนที่จะส่งการถอนเงินครั้งที่สอง คุณต้องรอให้การถอนเงินครั้งแรกได้รับการอนุมัติเพื่อตรวจสอบ"
			},
			{
				"Q": " ทำไมหลังจากยกเลิกการถอนเงินแล้ว เงินไม่คืนเข้าบัญชีซื้อขายของฉันทันที?",
				"A": "หลังจากยกเลิกการถอน เงินจะถูกส่งคืนไปยังกระเป๋าเงินหลักของคุณโดยอัตโนมัติ จากนั้นจึงสามารถโอนเงินจากกระเป๋าเงินหลักไปยังบัญชีซื้อขายได้"
			}
		],
		2: [
			{
				"Q": " ฉันสามารถซื้อขายผลิตภัณฑ์อะไรบน EBC ได้บ้าง?",
				"A": " EBC นำเสนอผลิตภัณฑ์ที่หลากหลาย และคุณต้องการเพียงบัญชีซื้อขายเดียวเพื่อสร้างพอร์ตโฟลิโอที่หลากหลาย <a href=\"/tradingproduct\">คลิกที่นี่เพื่อดูรายการผลิตภัณฑ์ทั้งหมด</a> -"
			},
			{
				"Q": " ปริมาณการซื้อขายสูงสุดและต่ำสุดสำหรับบัญชีแต่ละประเภทคือเท่าใด?",
				"A": " ปริมาณการซื้อขายสูงสุดสำหรับบัญชี STD และบัญชี PRO คือ 40 ล็อต และปริมาณการซื้อขายขั้นต่ำจะแตกต่างกันไปขึ้นอยู่กับความหลากหลายของการซื้อขาย หากคุณต้องการทราบรายละเอียดเพิ่มเติมกรุณา <a href=\"/TradingAccount\">คลิกที่นี่เพื่อดูกฎบัญชี</a> -"
			},
			{
				"Q": " Market Execution คืออะไร และ Pending Order คืออะไร",
				"A": "การดำเนินการตามตลาดหมายความว่าคำสั่งซื้อจะดำเนินการทันที และนักลงทุนซื้อหรือขายตามราคาที่ดีที่สุดในตลาดปัจจุบัน ธุรกรรมคำสั่งซื้อที่รอดำเนินการคือการดำเนินการตามกำหนดเวลา โดยนักลงทุนจะกำหนดราคาซื้อและขายที่คาดหวัง เมื่อราคาตลาดถึงหรือสูงกว่าราคาที่คาดไว้ ระบบการซื้อขายจะดำเนินการธุรกรรมโดยอัตโนมัติ"
			},
			{
				"Q": " Buy Limit, Buy Stop, Sell Limit, Sell Stop คืออะไร?",
				"A": " วงเงินซื้อ: ซื้อเมื่อราคาตกลงถึงระดับที่ต่ำกว่าที่กำหนดไว้ล่วงหน้า เหมาะสำหรับกลยุทธ์การซื้อราคาต่ำ ตัวอย่างเช่น หากคาดว่าราคาทองคำจะลดลงจากปี 2000 ถึง 1980 แล้วเพิ่มขึ้นอีกครั้ง คุณสามารถกำหนด Buy Limit ไว้ที่ปี 1980 และรอซื้อในราคาที่ต่ำกว่า ขีดจำกัดการขาย:ขายเมื่อราคาสูงขึ้นถึงระดับที่สูงขึ้นที่กำหนดไว้ เหมาะสำหรับกลยุทธ์การขายที่มีราคาสูง ตัวอย่างเช่น หากคาดว่าราคาทองคำจะเพิ่มขึ้นจากปี 2000 เป็น 2020 แล้วลดลงอีกครั้ง คุณสามารถกำหนด Sell Limit สำหรับปี 2020 และรอขายในราคาที่สูงได้ ซื้อหยุด : ซื้อเมื่อราคาสูงขึ้นถึงระดับที่สูงขึ้นที่กำหนดไว้ล่วงหน้า เหมาะสำหรับกลยุทธ์ไล่ตาม ตัวอย่างเช่น หากคุณเชื่อว่าแนวโน้มขาขึ้นสามารถยืนยันได้เมื่อราคาทองคำเกินปี 2020 เท่านั้น คุณสามารถตั้งค่า Buy Stop สำหรับปี 2020 และรอการทะลุทะลวงขาขึ้นก่อนที่จะซื้อ หยุดขาย: ขายเมื่อราคาตกลงถึงระดับที่ต่ำกว่าที่กำหนดไว้ล่วงหน้า เหมาะสำหรับกลยุทธ์การไล่ตาม ตัวอย่างเช่น หากคุณเชื่อว่าแนวโน้มขาลงสามารถยืนยันได้หากราคาทองคำตกลงต่ำกว่าปี 1980 เท่านั้น คุณสามารถตั้งค่า Sell Stop ที่ปี 1980 และรอให้ราคาลดลงต่ำกว่าปี 1980 ก่อนจึงจะขาย"
			},
			{
				"Q": " ระดับ Stop Out คืออะไร?",
				"A": " ระดับหยุดอยู่ที่ 30%"
			},
			{
				"Q": "จะตั้งค่า 'take Profit' และ 'Stop Loss' ในคำสั่งซื้อของฉันได้อย่างไร?",
				"A": " MT4: พีซี ขั้นตอนในการตั้งค่า Stop Loss และ Take Profit มีดังนี้: 1. เลือกคำสั่งซื้อขายที่คุณต้องการจัดการ 2. คลิกขวาที่คำสั่งซื้อแล้วเลือก \"แก้ไขหรือลบคำสั่งซื้อ\" 3. ตั้งค่า \"Stop Loss Price\" และ \"Profit Price\" ในหน้าต่างที่ปรากฏขึ้น MT4: มือถือ ขั้นตอนในการตั้งค่า Stop Loss และ Take Profit มีดังนี้: 1. ค้นหาคำสั่งซื้อตำแหน่งที่คุณต้องการแก้ไขในหน้า \"การซื้อขาย\" 2 คลิกหรือกดคำสั่งซื้อค้างไว้แล้วเลือก \"แก้ไข\" ในเมนูป๊อปอัป 3. ตั้งค่า \"Stop Loss Price\" และ \"Profit Price\" ในหน้าต่างที่ปรากฏขึ้น"
			},
			{
				"Q": " การป้องกันความเสี่ยงคืออะไร?",
				"A": " การป้องกันความเสี่ยงเป็นคำสั่งเปิดของพันธุ์เดียวกัน ขนาดล็อตเดียวกัน แต่ไปในทิศทางตรงกันข้าม"
			},
			{
				"Q": " EBC ให้สัญญาณการซื้อขายหรือไม่?",
				"A": "แม้ว่าเราจะไม่เสนอสัญญาณการซื้อขายโดยตรง แต่เราให้การเข้าถึงชุมชนการซื้อขายของเรา ภายในชุมชนนี้ คุณสามารถเลือกสัญญาณการซื้อขายที่หลากหลายจากผู้ใช้ชุมชนรายอื่น"
			},
			{
				"Q": " EBC รองรับ EA (ที่ปรึกษาผู้เชี่ยวชาญ) หรือไม่",
				"A": " ใช่. คุณสามารถใช้ EA ใดก็ได้ที่คุณต้องการ"
			}
		],
		3: [
			{
				"Q": " ฉันสามารถใช้เทอร์มินัลการซื้อขายใดได้บ้าง?",
				"A": " ปัจจุบัน EBC รองรับการใช้งานเทอร์มินัลการซื้อขาย MT4 เท่านั้น <a href=\"/MT4\">คลิกที่นี่เพื่อดาวน์โหลดทันที</a> -"
			},
			{
				"Q": " ฉันควรใช้เซิร์ฟเวอร์ใดสำหรับแพลตฟอร์ม MT4?",
				"A": " สำหรับบัญชีจริงของ EBC เราใช้เซิร์ฟเวอร์ EBCFinancialGroupKY-Live และสำหรับบัญชีทดลองเราใช้เซิร์ฟเวอร์ EBCFinancialGroupKY-Demo"
			},
			{
				"Q": " เหตุใดฉันจึงไม่สามารถเข้าสู่ระบบ Terminal การซื้อขายได้?",
				"A": " การเข้าสู่ระบบล้มเหลวใน แพลตฟอร์มการซื้อขายอาจเกิดจาก ผู้ใช้ป้อนรหัสผ่านไม่ถูกต้อง หรือ มันอาจจะเกี่ยวข้องกับกการเชื่อมต่อเครือข่ายล้มเหลว เมื่อประสบปัญหาในการเข้าสู่ระบบ ขอแนะนำให้ป้อนรหัสผ่านของคุณอีกครั้งหรือตรวจสอบการเชื่อมต่อเครือข่ายของคุณก่อน"
			},
			{
				"Q": " ไม่สามารถเข้าสู่ระบบ MT4 ได้ เพราะเหตุใดจึงมีข้อผิดพลาด \"บัญชีที่ไม่ถูกต้อง\" ปรากฏขึ้น",
				"A": " เมื่อข้อความแจ้ง \"บัญชีไม่ถูกต้อง\" ปรากฏขึ้น อาจเป็นเพราะคุณป้อนข้อมูลเซิร์ฟเวอร์ไม่ถูกต้องหรือรหัสผ่านไม่ถูกต้อง ปัญหานี้สามารถแก้ไขได้โดยเลือกเซิร์ฟเวอร์ที่ถูกต้องและป้อนรหัสผ่านให้ถูกต้อง"
			},
			{
				"Q": " เหตุใดจึงแสดงข้อความแจ้งว่า \"ไม่มีการเชื่อมต่อ\"",
				"A": " หากคุณพบข้อผิดพลาด 'ไม่มีการเชื่อมต่อ' อาจเป็นเพราะเซิร์ฟเวอร์ถูกตัดการเชื่อมต่อหรือมีปัญหากับการเชื่อมต่อเครือข่ายท้องถิ่น ขั้นแรกให้ตรวจสอบว่าเครือข่ายท้องถิ่นสามารถท่องเว็บได้ตามปกติหรือไม่ หากเครือข่ายเป็นปกติ ให้ลองสลับไปยังเซิร์ฟเวอร์ศูนย์ข้อมูล (DC) อื่นแล้วเชื่อมต่อใหม่"
			},
			{
				"Q": " ทำไมปุ่ม \"คำสั่งซื้อใหม่\" จึงเป็นสีเทา?",
				"A": " หากคุณไม่สามารถสร้างคำสั่งซื้อใหม่ได้อาจเนื่องมาจากสาเหตุดังต่อไปนี้: 1. บัญชีเชื่อมต่อไม่สำเร็จหรือถูกตัดการเชื่อมต่อ 2. ใช้รหัสผ่านแบบอ่านอย่างเดียวเพื่อเข้าสู่ระบบ รหัสผ่านประเภทนี้อนุญาตให้คุณดูบัญชีเท่านั้นและไม่สามารถดำเนินการธุรกรรมได้ 3. บัญชี STD สามารถซื้อขายได้เฉพาะสัญลักษณ์ที่มีส่วนต่อท้าย \".s\" เท่านั้น ในขณะที่ประเภทต่างๆ ในพื้นที่สีเทาไม่สามารถซื้อขายได้"
			},
			{
				"Q": " จะเพิ่มหรือลบสัญลักษณ์ได้อย่างไร?",
				"A": " วิธีเพิ่มหรือซ่อนสัญลักษณ์บางตัวใน MT4 ผ่านทาง เทอร์มินัลเดสก์ท็อป 1. เข้าสู่ระบบ Terminal การซื้อขายและคลิกขวาที่ใดก็ได้ 2. เลือก \"ประเภทการซื้อขาย\" 3. เลือกกลุ่มสัญลักษณ์การซื้อขาย 4. ดับเบิลคลิกเพื่อเพิ่มไปที่ \"ราคาตลาด\" 5. หากต้องการซ่อน ให้เลือก \"ซ่อน\" เทอร์มินัลมือถือ1. เข้าสู่ระบบและคลิก \"+\" ที่มุมขวาบน 2. เลือกกลุ่มสัญลักษณ์การซื้อขาย 3. คลิก \"+\" เพื่อเพิ่ม หากต้องการลบความหลากหลายบนเทอร์มินัลมือถือ: 1. คลิกปุ่มรูปปากกาที่มุมซ้ายบน 2. ทำเครื่องหมายที่ช่องเพื่อลบหมวดหมู่แล้วคลิกลบ"
			},
			{
				"Q": " วิธีการตั้งค่าเส้นราคาเสนอ?",
				"A": " เดสก์ท็อป 1. คลิกขวาที่ใดก็ได้บนแผนภูมิ 2. เลือก \"คุณสมบัติ\" เพื่อเข้าสู่การตั้งค่าการแสดงผล 3. ตรวจสอบตัวเลือก \"เส้นราคาซื้อ\" iOS: 1. เปิดแผนภูมิ 2. คลิกที่ใดก็ได้และเลือก \"การตั้งค่า\" 3. ตรวจสอบตัวเลือก \"เส้นราคาซื้อ\" Android: 1. เข้าสู่เมนูการตั้งค่า 2. เลือก \"แผนภูมิ\" 3. ตรวจสอบตัวเลือก Bid Line เพื่อเปิดใช้งาน"
			},
			{
				"Q": " ฉันจะอัพเดตเขตเวลาใน MT4 ได้อย่างไร?",
				"A": " น่าเสียดายที่ไม่มีตัวเลือกในการอัปเดตเขตเวลาใน MT4 Terminal"
			},
			{
				"Q": " เหตุใดคำสั่งซื้อที่รอดำเนินการของฉันจึงไม่ดำเนินการ?",
				"A": "สาเหตุต่อไปนี้อาจทำให้ไม่สามารถดำเนินการคำสั่งที่รอดำเนินการได้: 1. หลักประกันว่างที่มีอยู่ในบัญชีไม่เพียงพอที่จะเปิดตำแหน่งใหม่ 2. ราคาของคำสั่งที่รอดำเนินการไม่ถูกต้องและไม่เป็นไปตามมาตรฐานการดำเนินการของคำสั่งที่รอดำเนินการ 3. เมื่อมีการประกาศเหตุการณ์ทางการเงินที่สำคัญ ตลาดอาจมีความผันผวน และราคาที่แท้จริงของคำสั่งซื้อขายอาจแตกต่างจากราคาคำสั่งซื้อที่รอดำเนินการ โปรดทราบว่าความล้มเหลวของคำสั่งที่รอดำเนินการที่จะดำเนินการไม่ได้จำกัดอยู่เพียงเหตุผลข้างต้น และจะต้องพิจารณาตามสถานการณ์เฉพาะในขณะนั้น"
			},
			{
				"Q": " วิธีที่ดีที่สุดในการตรวจสอบชั่วโมงการซื้อขายสำหรับสัญลักษณ์ทั้งหมดคืออะไร?",
				"A": " เข้าสู่ระบบเทอร์มินัลการซื้อขาย MT4 คลิกขวาที่สัญลักษณ์การซื้อขายที่คุณต้องการดู และคลิก \"ข้อมูลจำเพาะ\" เพื่อดู"
			},
			{
				"Q": " เหตุใดจึงแจ้งข้อผิดพลาด \"SL/TP ไม่ถูกต้อง\"",
				"A": "ข้อผิดพลาด \"SL/TP ไม่ถูกต้อง\" อาจเกิดจากสาเหตุต่อไปนี้: 1. ราคาปัจจุบันเกินจุด Take-Profit และ Stop-Loss ที่ตั้งไว้ และธุรกรรมไม่สามารถดำเนินการให้เสร็จสิ้นได้ 2. ราคาคำสั่งซื้อของบัญชี STD จะต้องอยู่ที่ ≥ 50 จากราคาล่าสุด"
			},
			{
				"Q": " เพราะเหตุใดข้อความ \"ปิดตลาด\" จึงปรากฏขึ้น",
				"A": " เมื่อตลาดปิด ข้อความ \"ตลาดปิด\" จะปรากฏขึ้น"
			},
			{
				"Q": " ฉันสามารถปิดตำแหน่งของฉันบางส่วน (ลดจำนวนตำแหน่งที่เปิด) ได้หรือไม่?",
				"A": " ตำแหน่งของคุณสามารถปิดได้บางส่วน คุณอาจเลือกที่จะปิดสถานะบางส่วนได้หากในปัจจุบันเกินข้อกำหนดล็อตการซื้อขายขั้นต่ำสำหรับสินค้าโภคภัณฑ์"
			},
			{
				"Q": " ฉันยังสามารถซื้อขายหลังจากที่ตลาดปิดได้หรือไม่?",
				"A": " คุณไม่สามารถซื้อขายได้อีกต่อไปเมื่อตลาดปิด คุณสามารถซื้อขายได้เฉพาะ (เปิด ปิด ดำเนินการ และแก้ไขคำสั่งซื้อ) เมื่อตลาดเปิดเท่านั้น"
			},
			{
				"Q": " หาก MT4 ของฉันออฟไลน์ ฉันจำเป็นต้องปิดตำแหน่งทั้งหมดที่ฉันเปิดหรือไม่",
				"A": "หากคุณปิดระบบการซื้อขาย MT4 การทำกำไร การหยุดการขาดทุน และคำสั่งซื้อที่รอดำเนินการจะยังคงอยู่ แต่เมื่อคุณปิดระบบการซื้อขาย MT4 Trailing Stop Loss และระบบการซื้อขาย EA ของคุณจะไม่ถูกต้อง"
			},
			{
				"Q": " จะดูประวัติการทำธุรกรรมของฉันได้อย่างไร?",
				"A": " 1. เข้าสู่ระบบเทอร์มินัลการซื้อขาย MT4 2. คลิกที่การนำทาง \"เทอร์มินัล\" - \"ประวัติบัญชี\" 3. ดูประวัติการทำธุรกรรมที่ปิดไปแล้ว"
			},
			{
				"Q": " ฉันจะส่งออกประวัติการทำธุรกรรมได้อย่างไร?",
				"A": " 1. เข้าสู่ระบบเทอร์มินัลการซื้อขาย MT4 และคลิก \"ประวัติบัญชี\" 2. คลิกขวาที่เมาส์และเลือก \"บันทึกเป็นใบแจ้งยอดบัญชีโดยละเอียด\""
			},
			{
				"Q": " จะดูเส้นโค้งทุนใน MT4 ได้อย่างไร?",
				"A": " 1. เปิดประวัติบัญชีใน MT4 2. คลิกขวาที่เมาส์แล้วเลือก \"บันทึกเป็นใบแจ้งยอดบัญชีโดยละเอียด\" 3. คลิกกราฟที่บันทึกไว้อีกครั้งเพื่อดูเส้นโค้งเงินทุน"
			},
			{
				"Q": " PAMM คืออะไรและใช้งานอย่างไร?",
				"A": "PAMM ย่อมาจาก Percent Allocation Management Model ซึ่งเป็นรูปแบบหนึ่งของกองทุนซื้อขายรวมสำหรับการจัดการ นักลงทุนสามารถเลือกเทรดเดอร์หรือผู้จัดการกองทุนที่มีคุณสมบัติเหมาะสมเพื่อใช้เงินทุนของตนเองและกองทุนรวมเพื่อทำธุรกรรมเพื่อรับผลกำไร และกระจายผลกำไรตามอัตราส่วนที่ตกลงกันไว้"
			}
		],
		4: [
			{
				"Q": " การซื้อขายอนุพันธ์คืออะไร?",
				"A": " ตลาดซื้อขายอนุพันธ์ในปัจจุบันเป็นตลาดซื้อขายทางการเงินที่ใหญ่ที่สุดในโลก โดยมีปริมาณการซื้อขายเฉลี่ยต่อวันประมาณ 4 ล้านล้านเหรียญสหรัฐ อัตราแลกเปลี่ยนของสกุลเงินต่างๆ ในโลกเป็นแบบลอยตัวและปรากฏในรูปแบบของคู่สกุลเงินเมื่อทำการซื้อขาย เช่น ยูโร/USD (EUR/USD) และ USD/JPY (USD/JPY) มันแสดงถึงวิธีการซื้อขายในการซื้อสกุลเงินหนึ่งและขายสกุลเงินอื่นในคู่สกุลเงิน"
			},
			{
				"Q": " สเปรดคืออะไร?",
				"A": " สเปรดคือความแตกต่างระหว่างราคาซื้อและราคาขายของผลิตภัณฑ์การซื้อขายบางอย่าง และยังเป็นต้นทุนธุรกรรมที่ต้องชำระสำหรับแต่ละธุรกรรมด้วย"
			},
			{
				"Q": "เลเวอเรจคืออะไร?",
				"A": " เลเวอเรจหมายความว่านักลงทุนสามารถใช้เงินทุนในสัดส่วนเล็กน้อยเพื่อลงทุนในเป้าหมายอัตราแลกเปลี่ยนเงินตราต่างประเทศที่มีมูลค่ามากกว่าโดยไม่จำเป็นต้องทำธุรกรรมทั้งหมด ระดับเลเวอเรจจะกำหนดจำนวนมาร์จิ้นที่ครอบครอง"
			},
			{
				"Q": " มาร์จิ้นคืออะไร?",
				"A": "มาร์จิ้นหรือที่เรียกว่าการชำระเงินล่วงหน้า ช่วยให้เทรดเดอร์สามารถใช้เงินทุนส่วนหนึ่งเพื่อสร้างสถานะตามหลักการของการลงทุนแบบเลเวอเรจ มันทำหน้าที่เป็นหลักประกันในการรักษาสถานะการซื้อขาย ในตลาด โดยทั่วไปเลเวอเรจจะอยู่ในช่วง 20 ถึง 500 เท่า ทำให้นักลงทุนสามารถซื้อขายด้วยเลเวอเรจสูงได้ อย่างไรก็ตาม สิ่งสำคัญที่ควรทราบคือแม้ว่าระบบมาร์จิ้นจะช่วยเพิ่มผลกำไรได้ แต่ก็ยังเพิ่มความเสี่ยงในการทำธุรกรรมด้วย ตัวอย่างเช่น ลองพิจารณาคุณ Zhao ที่ต้องการทำธุรกรรมมูลค่า 100,000 ดอลลาร์สหรัฐในวันนี้ ด้วยการซื้อขายมาร์จิ้นและสมมติว่าอัตราส่วนเลเวอเรจอยู่ที่ 500:1 นาย Zhao จะต้องมีเงินเพียง 200 ดอลลาร์สหรัฐในการทำธุรกรรมนี้ (100,000/500 = 200 ดอลลาร์สหรัฐ) กล่าวอีกนัยหนึ่ง ด้วยเงินทุนที่เพิ่มขึ้น 500 เท่า การลงทุน 10,000 ดอลลาร์สหรัฐฯ สามารถอำนวยความสะดวกในการทำธุรกรรมมูลค่า 5 ล้านดอลลาร์สหรัฐฯ ได้"
			},
			{
				"Q": " จะคำนวณมาร์จิ้นที่จำเป็นในการเปิดคำสั่งซื้อขายได้อย่างไร?",
				"A": "มาร์จิ้น = ขนาดสัญญา * ราคาปัจจุบัน / เลเวอเรจ * จำนวนล็อต สูตรนี้กำหนดมาร์จิ้นที่จำเป็นในการเริ่มต้นคำสั่งซื้อ โดยจะพิจารณาปัจจัยต่างๆ เช่น ขนาดสัญญา (ขนาดของตำแหน่ง) ราคาปัจจุบันของสินทรัพย์ เลเวอเรจที่โบรกเกอร์ให้ไว้ และจำนวนล็อตที่ซื้อขาย"
			},
			{
				"Q": " ความสัมพันธ์ระหว่างยอดดุล ทุน และมาร์จิ้นที่มีอยู่ในการซื้อขายคืออะไร?",
				"A": " ส่วนของผู้ถือหุ้น = ยอดคงเหลือ – ส่วนต่างที่ถูกครอบครอง ± กำไรและขาดทุนลอยตัว แต่ละคำหมายถึงอะไร: สมดุล : นี่คือจำนวนเงินทั้งหมดในบัญชีซื้อขาย อัตรากำไรขั้นต้นที่ถูกครอบครอง: มาร์จิ้นที่ผูกไว้กับสถานะที่เปิดอยู่ในปัจจุบัน กำไรและขาดทุนลอยตัว กำไรหรือขาดทุนที่ยังไม่เกิดขึ้นจริงในตำแหน่งที่เปิดอยู่ ซึ่งมีความผันผวนตามการเปลี่ยนแปลงของตลาด ส่วนของผู้ถือหุ้นคือมูลค่าสุทธิของบัญชีการซื้อขายหลังจากการบัญชีสำหรับมาร์จิ้นที่เชื่อมโยงกับสถานะที่เปิดอยู่และกำไรหรือขาดทุนลอยตัวใดๆ มันสะท้อนถึงมูลค่าแบบเรียลไทม์ของบัญชีและเป็นปัจจัยสำคัญในการกำหนดมาร์จิ้นที่มีอยู่สำหรับกิจกรรมการซื้อขายเพิ่มเติม"
			},
			{
				"Q": " เหตุใดยอดคงเหลือติดลบจึงเกิดขึ้น?",
				"A": " ยอดคงเหลือติดลบอาจเกิดขึ้นในช่วงสภาวะตลาดที่รุนแรง เมื่อตลาดไม่สามารถให้ราคาการทำธุรกรรมที่สมเหตุสมผลได้ สถานการณ์นี้อาจนำไปสู่การสูญเสียธุรกรรมขั้นสุดท้ายเกินยอดคงเหลือในบัญชีและหลักประกัน ส่งผลให้ยอดคงเหลือติดลบในบัญชี"
			},
			{
				"Q": " อะไรคือความแตกต่างระหว่างมาร์จิ้น (เงินดาวน์) และมาร์จิ้นที่มีอยู่ (เงินดาวน์ที่มีอยู่)?",
				"A": " มาร์จิ้นหมายถึงเงินทุนที่โบรกเกอร์ถือไว้เพื่อรักษาคำสั่งซื้อที่เปิดอยู่ อิควิตี้ที่เหลืออยู่ในบัญชีเรียกว่ามาร์จิ้นที่มีอยู่"
			},
			{
				"Q": " Slippage ของราคาตลาดเกิดขึ้นได้อย่างไร?",
				"A": "ในตลาด หากปริมาณที่มีอยู่ไม่เพียงพอที่จะตอบสนองคำสั่งซื้อในราคาปัจจุบัน ส่วนที่เหลือจะถูกดำเนินการในราคาถัดไปที่มีอยู่ ส่วนต่างของราคานี้เรียกว่าการคลาดเคลื่อนของราคา Slippage อาจเป็นประโยชน์ (Slippage เชิงบวก) หรือเป็นผลเสีย (Slippage เชิงลบ) สำหรับนักลงทุน ขึ้นอยู่กับว่าราคาที่ดำเนินการเป็นที่น่าพอใจมากกว่าหรือน้อยกว่าที่คาดไว้"
			},
			{
				"Q": " เลเวอเรจมีผลกระทบต่อ Stop Out อย่างไร?",
				"A": " เลเวอเรจสามารถเพิ่มผลตอบแทนการลงทุน แต่ยังเพิ่มความเสี่ยงอีกด้วย เลเวอเรจที่สูงขึ้นหมายถึงต้องใช้มาร์จิ้นน้อยลง เพิ่มการใช้เงินทุน และช่วยให้มีสถานะที่สามารถซื้อขายได้มากขึ้น อย่างไรก็ตาม ในช่วงที่ตลาดมีความผันผวนสูงและมาร์จิ้นไม่เพียงพอ อาจเกิด Stop Out ได้"
			},
			{
				"Q": " ดอกเบี้ยข้ามคืนคืออะไร?",
				"A": "ดอกเบี้ยข้ามคืนหรือที่เรียกว่าสวอป หมายถึงดอกเบี้ยที่ได้รับหรือจ่ายโดยเทรดเดอร์เมื่อพวกเขาถือสถานะข้ามคืน ดอกเบี้ยนี้คำนวณเวลา 22.00 น. ตามเวลาลอนดอน อัตราดอกเบี้ยข้ามคืนขึ้นอยู่กับทิศทางของสถานะของเทรดเดอร์และส่วนต่างของอัตราดอกเบี้ยระหว่างสกุลเงินที่เกี่ยวข้อง ตัวอย่างเช่น หากอัตราดอกเบี้ยสำหรับเงินปอนด์สูงกว่าเงินเยนของญี่ปุ่นอย่างมาก เทรดเดอร์ที่ถือ GBP/JPY ในตำแหน่งซื้อจะได้รับดอกเบี้ย ในขณะที่เทรดเดอร์ที่ถือ GBP/JPY ในตำแหน่งขายจะต้องเสียดอกเบี้ย"
			},
			{
				"Q": " จะตรวจสอบอัตราดอกเบี้ยข้ามคืนได้อย่างไร?",
				"A": "วิธีการสอบถาม Swap ของสัญญามีดังต่อไปนี้: 1. ล็อกอินเข้าสู่ Terminal การซื้อขาย MT4; 2. คลิกที่เมนูหลัก \"ดิสเพลย์\" - \"รายการผลิตภัณฑ์การซื้อขาย\" 3. คลิกขวาที่ผลิตภัณฑ์การซื้อขายที่คุณต้องการดูสวอป แล้วคลิก \"ข้อมูลจำเพาะ\" 4. \"ค่าธรรมเนียมการขาย/ซื้อสินค้าคงคลังช่วงระยะเวลาเดียว\" คือดอกเบี้ยข้ามคืน (ปล.: เทรดเดอร์จะมอบดอกเบี้ยข้ามคืนที่เป็นบวกให้กับลูกค้า)"
			},
			{
				"Q": " เงินปันผลคืออะไร และมีผลกระทบต่อการซื้อขายอย่างไร?",
				"A": " ในตลาด Contract for Difference (CFD) เงินปันผลหมายถึงการจ่ายดอกเบี้ยให้กับนักลงทุนที่ถือสถานะ Long CFD ในทางกลับกัน นักลงทุนที่ถือสถานะขายมักจะต้องจ่ายค่าธรรมเนียมที่เกี่ยวข้อง"
			},
			{
				"Q": " ชั่วโมงการซื้อขายสำหรับการซื้อขายทองคำและเงินแบบทันทีคือเมื่อใด?",
				"A": " ชั่วโมงการซื้อขายทองคำและเงินของเราคือตั้งแต่วันอาทิตย์ 23:00 น. ถึงวันศุกร์ 22:00 น. ตามเวลาลอนดอน โปรดทราบว่าตลาดจะปิดให้บริการเป็นเวลาสั้น ๆ ตั้งแต่เวลา 22:00 น. - 23:00 น. ทุกวัน"
			},
			{
				"Q": "สัญญาสปอตทองคำและเงินมีค่าเท่ากับกี่ออนซ์?",
				"A": " สัญญาทองคำสปอต: 1 ล็อต = 100 ออนซ์ สัญญาซิลเวอร์สปอต: 1 ล็อต = 5,000 ออนซ์"
			},
			{
				"Q": " จะคำนวณมาร์จิ้น (ชำระเงินล่วงหน้า) ที่จำเป็นสำหรับการทำธุรกรรมสปอตทองคำและเงินได้อย่างไร?",
				"A": " หากราคาทองคำปัจจุบันคือ 2,000 ดอลลาร์สหรัฐ/ออนซ์ เลเวอเรจคือ 500 เท่า และธุรกรรมคือ 0.1 ล็อต ดังนั้นมาร์จิ้นที่ต้องการสำหรับทองคำ = 2000*100/500*0.1=40USD หากราคาเงินปัจจุบันคือ 23 ดอลลาร์สหรัฐ/ออนซ์ เลเวอเรจคือ 500 เท่า และธุรกรรมคือ 0.1 ล็อต จากนั้นมาร์จิ้นที่ต้องการสำหรับทองคำ = 23*5000/500*0.1=23USD"
			},
			{
				"Q": " สัญญาสปอตทองคำและเงินมีอายุการใช้งานหรือไม่?",
				"A": " ไม่ ตราบใดที่คุณรักษาหลักประกันในบัญชีของคุณเพียงพอ ตำแหน่งของคุณจะยังคงใช้ได้จนกว่าคุณจะปิดมัน"
			},
			{
				"Q": " อะไรคือความแตกต่างระหว่างน้ำมันดิบเบรนท์ (XBRUSD) และน้ำมันดิบเวสต์เท็กซัส (XTIUSD)?",
				"A": "น้ำมันดิบสามารถแบ่งออกเป็นน้ำมันดิบเบาและน้ำมันดิบหนักตามแรงโน้มถ่วง API และยังสามารถแบ่งออกเป็นน้ำมันดิบที่มีกำมะถันและน้ำมันดิบหวานตามปริมาณกำมะถัน น้ำมันดิบเบรนต์ (XBRUSD) เป็นน้ำมันดิบชนิดเบาที่ผลิตจากแหล่งน้ำมันหลายแห่งในมหาสมุทรแอตแลนติกเหนือ West Texas Intermediate (XTIUSD) ซึ่งค่อนข้างเบากว่าและมีปริมาณกำมะถันต่ำกว่า มักเสนอราคาลดราคาให้กับ Brent"
			}
		]
	}
}